import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faTwitter } from '@fortawesome/free-brands-svg-icons';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import withI18next from '~/../hocs/_withI18next';
import Config from '~/config';

@withI18next()
class ModalShare extends Component {
  state = {
    showModalUserIcon: false,
  };

  closeModalUserIcon(e) {
    e.preventDefault();
    this.setState(
      {
        showModalUserIcon: !this.state.showModalUserIcon,
      },
      () => this.props.onDownload(),
    );
  }

  isPremium() {
    const { profile = {} } = this.props;

    return !!(profile.role && profile.role.toUpperCase() === 'PREMIUM');
  }

  openModalUserIcon = (e) => {
    e.preventDefault();
    const { profile = {} } = this.props;

    if (profile.role && profile.role.toUpperCase() === 'PREMIUM') {
      return this.props.onDownload();
    }

    if (!this.props.isAuthenticated) {
      // return this.props.openLoginModal();
      window.location.href = `${Config.ssoServerUrl}/login?lang=${
        this.props.lng
      }&serviceURL=${encodeURIComponent(
        process.browser ? window.location.href : '',
      )}`;
    }
    this.setState({
      showModalUserIcon: !this.state.showModalUserIcon,
    });
  };

  closeModal(e) {
    this.setState({
      showModalUserIcon: !this.state.showModalUserIcon,
    });
  }

  onSocialShare = (link) => {
    window.open(
      link,
      'share',
      `height=450, width=550, top=${window.innerHeight / 2 - 275}, left=${
        window.innerWidth / 2 - 225
      }, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0`,
    );
  };

  render() {
    const { t, currentLanguage } = this.props;
    return (
      <div className="static-modal">
        <Modal
          show={this.props.show}
          onHide={this.props.onClose}
          bsSize="small"
        >
          <Modal.Header>
            <h3 className="text-center">{t('to_continue_download')}</h3>
          </Modal.Header>
          <Modal.Body>
            <p className="text-center font-size-16">
              {t('Please help us to share this page')}
            </p>
            <div onClick={this.props.onShare}>
              <div className="font-size-25">
                <button
                  className="btn btn-md btn-ac-primary btn-blue btn-block"
                  onClick={() => {
                    this.onSocialShare(
                      `https://twitter.com/intent/tweet/?text=&amp;url=${window.location.href}`,
                    );
                  }}
                >
                  <FontAwesomeIcon icon={faTwitter} style={{ width: '1em' }} />
                  &nbsp;
                  <strong>{t('Share on Twitter')}</strong>
                </button>
                <button
                  className="btn btn-md btn-ac-primary btn-primary btn-block"
                  onClick={() => {
                    this.onSocialShare(
                      `https://facebook.com/sharer/sharer.php?u=${window.location.href}`,
                    );
                  }}
                >
                  <FontAwesomeIcon icon={faFacebook} style={{ width: '1em' }} />
                  &nbsp;
                  <strong>{t('Share on Facebook')}</strong>
                </button>
                <br />
              </div>
            </div>
            <p
              style={{
                fontSize: 12,
                fontWeight: 500,
                marginLeft: 9,
                textAlign: 'center',
              }}
              dangerouslySetInnerHTML={{
                __html: t('Join_premium_design_ac', { currentLanguage }),
              }}
            />
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

ModalShare.defaultProps = {
  show: false,
};

ModalShare.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onShare: PropTypes.func,
};

export default ModalShare;
